import { fromPromise } from "apollo-link";
import { onError } from "apollo-link-error";

import { setLocalValue } from "../lib/helpers/localStorageHelpers";
import { getNewToken } from "./apolloHelpers";

const isJwtAuthError = (err: any) => {
  const text = [err?.message, err?.debugMessage, err?.extensions?.code]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  return (
    text.includes("invalid-jwt") ||
    text.includes("expired-jwt") ||
    text.includes("jwt is expired") ||
    text.includes("iss do not match") ||
    text.includes("signature verification failed") ||
    text.includes("wrong number of segments")
  );
};

export const errorLink = onError(
  ({ graphQLErrors, operation, forward }) => {
    if (!graphQLErrors) {
      return;
    }

    const hasExpiredTokenError = graphQLErrors.some(isJwtAuthError);
    const alreadyRetried = operation.getContext().authRetry;

    if (!hasExpiredTokenError || alreadyRetried) {
      return;
    }

    operation.setContext({
      ...operation.getContext(),
      authRetry: true,
    });

    return fromPromise(
      getNewToken().catch(() => {
        return null;
      })
    ).flatMap((accessToken): any => {
      if (!accessToken) {
        return;
      }

      setLocalValue("authToken", accessToken);
      operation.setContext(({ headers = {} }) => ({
        headers: {
          ...headers,
          authorization: `Bearer ${accessToken}`,
        },
      }));

      return forward(operation);
    });
  }
);
